import { get, post, remove } from './api.js'

// ORGANISATION CRUD
export function callGetOrganisation(orgId) {
  return get(`/api/auth/cloud/organisation/${orgId}/get-organisation`)
}

export function callUpdateOrganisation(orgId, organisation) {
  return post(
    `/api/auth/cloud/organisation/${orgId}/update-organisation`,
    organisation,
  )
}

// DASHBOARD/STATS CRUD
export function callGetStatsPostCounter(orgId) {
  return get(`/api/auth/cloud/organisation/${orgId}/get-post-count-stats`)
}

export function callSendEmailPostPack(orgId, payload) {
  return post(
    `/api/auth/cloud/organisation/${orgId}/send-post-pack-request-email`,
    payload,
  )
}

export function callGetStatsStudentReach(orgId) {
  return get(`/api/auth/cloud/organisation/${orgId}/get-cw-student-reach-stats`)
}

export function callGetStatsSchools(orgId, regionId = null) {
  return post(`/api/auth/cloud/organisation/${orgId}/get-cw-schools`, regionId)
}

export function callGetStatsRegions(orgId) {
  return get(`/api/auth/cloud/organisation/${orgId}/get-cw-regions`)
}

export function callGetStatsMailouts(orgId, dateRange) {
  return post(
    `/api/auth/cloud/organisation/${orgId}/get-cw-mail-stats`,
    dateRange,
  )
}

export function callGetStatsPostCategories(orgId, dateRange) {
  return post(
    `/api/auth/cloud/organisation/${orgId}/get-cw-post-stats`,
    dateRange,
  )
}

export function callGetStatsTopPosts(orgId, dateRange) {
  return post(
    `/api/auth/cloud/organisation/${orgId}/get-cloud-top-posts`,
    dateRange,
  )
}

export function callGetStatsOrganisationActivity(orgId) {
  return get(
    `/api/auth/cloud/organisation/${orgId}/get-organisation-activity-stats`,
  )
}

export function callGetStatsOrganisationPostShares(orgId, dateRange) {
  return post(
    `/api/auth/cloud/organisation/${orgId}/get-organisation-post-shares`,
    dateRange,
  )
}

export function callGetStatsOrganisationPostReach(orgId, dateRange) {
  return post(
    `/api/auth/cloud/organisation/${orgId}/get-organisation-post-reach`,
    dateRange,
  )
}

export function callGetStatsOrganisationPostCategories(orgId, dateRange) {
  return post(
    `/api/auth/cloud/organisation/${orgId}/get-organisation-post-categories-stats`,
    dateRange,
  )
}

export function callGetStatsPosts(orgId, payload) {
  return post(
    `/api/auth/cloud/organisation/${orgId}/get-posts-with-stats`,
    payload,
  )
}

export function callGetStatsPost(orgId, postId) {
  return get(`/api/auth/cloud/organisation/${orgId}/get-post-stats/${postId}`)
}

export function callGetStatsOrganisationContactActivity(orgId) {
  return get(
    `/api/auth/cloud/organisation/${orgId}/get-organisation-contact-activity-stats`,
  )
}

export function callGetStatsConnections(orgId, payload) {
  return post(
    `/api/auth/cloud/organisation/${orgId}/get-contacts-with-stats`,
    payload,
  )
}

export function callGetStatsConnection(orgId, connectionId) {
  return get(
    `/api/auth/cloud/organisation/${orgId}/get-contact-stats/${connectionId}`,
  )
}

// POSTS CRUD
export function callGetPosts(orgId, payload) {
  return post(`/api/auth/cloud/organisation/${orgId}/posts`, payload)
}

export function callGetPost(orgId, postId) {
  return get(`/api/auth/cloud/organisation/${orgId}/post/${postId}`)
}

export function callCreatePost(orgId, payload) {
  return post(`/api/auth/cloud/organisation/${orgId}/create-post`, payload)
}

export function callUpdatePost(orgId, payload) {
  return post(`/api/auth/cloud/organisation/${orgId}/update-post`, payload)
}

export function callDeletePost(orgId, postId) {
  return remove(`/api/auth/cloud/organisation/${orgId}/delete-post/${postId}`)
}

// RESOURCES CRUD
export function callSaveVideo(orgId, payload) {
  return post(
    `/api/auth/cloud/organisation/${orgId}/add-contributor-video-resource`,
    payload,
  )
}

export function callSaveFile(orgId, payload) {
  return post(
    `/api/auth/cloud/organisation/${orgId}/add-contributor-resource`,
    payload,
  )
}

export function callGetResources(orgId, payload) {
  return post(
    `/api/auth/cloud/organisation/${orgId}/contributor-resources`,
    payload,
  )
}

// CONNECTIONS CRUD
export function callGetConnectionsCounter(orgId) {
  return get(`/api/auth/cloud/organisation/${orgId}/get-contacts-counter`)
}

export function callGetConnections(orgId, payload) {
  return post(`/api/auth/cloud/organisation/${orgId}/get-contacts`, payload)
}

export function callGetConnection(orgId, connectionId) {
  return get(
    `/api/auth/cloud/organisation/${orgId}/get-contact/${connectionId}`,
  )
}

export function callUpsertConnection(orgId, id, payload) {
  return post(
    `/api/auth/cloud/organisation/${orgId}/upsert-contact${id ? `/${id}` : ''}`,
    payload,
  )
}

export function callRemoveConnection(orgId, id) {
  return remove(
    `/api/auth/cloud/organisation/${orgId}/remove-contact${id ? `/${id}` : ''}`,
  )
}

export function callSendEmailConnectionPack(orgId, payload) {
  return post(
    `/api/auth/cloud/organisation/${orgId}/send-contact-pack-request-email`,
    payload,
  )
}

export function callSendMessage(orgId, connectionId, payload) {
  return post(
    `/api/auth/cloud/organisation/${orgId}/send-message/${connectionId}`,
    payload,
  )
}

// ACCOUNTS

export function callGetAccounts(orgId, payload) {
  return post(`/api/auth/cloud/organisation/${orgId}/get-accounts`, payload)
}

export function callUpsertAccount(orgId, payload) {
  return post(
    `/api/auth/cloud/organisation/${orgId}/upsert-account${
      payload.id ? `/${payload.id}` : ''
    }`,
    payload,
  )
}

export function callDeleteAccount(orgId, accountId) {
  return remove(
    `/api/auth/cloud/organisation/${orgId}/delete-account/${accountId}`,
  )
}

// Public endpoints
export function callRegisterOrganisation(payload) {
  return post(`/api/cw-organiation-registration`, payload)
}

// PUBLIC PROFILE
export function callVerifyPublicProfile(payload) {
  return post(`/api/verify-organisation-profile`, payload)
}

export function callGetProfilePosts(orgId, payload) {
  return post(`/api/get-organisation-profile-posts/${orgId}`, payload)
}

export function callGetProfileConnections(orgId) {
  return post(`/api/get-organisation-profile-contacts/${orgId}`)
}

export function callGetProfileConnection(orgId, connectionId) {
  return get(`/api/get-organisation-profile-contact/${orgId}/${connectionId}`)
}

export function callSendProfileConnectionMessage(orgId, connectionId, payload) {
  return post(
    `/api/send-organisation-profile-contact-message/${orgId}/${connectionId}`,
    payload,
  )
}
